import React from 'react'
import Collect from 'meinian-package/src/component/collect'
import FastCollect from 'meinian-package/src/component/collect/fast'
import Icon from 'meinian-package/src/component/icon'
import Button from 'meinian-package/src/baseComponent/button'
import classNames from 'classnames'
import styles from './index.module.less'

export default ({ className, currentBlog, afterJoin = null, onCollectClick = null }) => {
  return <div className={classNames(styles['collect-group-btn'], className)}>
    <Collect
      hasCurInstated // 美念内部采集
      currentBlog={currentBlog}
      afterJoin={() => afterJoin?.()}
    >
      <Button
        className="collect-button"
        type="primary"
        onClick={onCollectClick}
      >
        采集
      </Button>
    </Collect>
    <div className="collect-button-dividing-line" />
    <FastCollect
      hasCurInstated
      currentBlog={currentBlog}
    >
      <Button
        className="fast-collect-button"
        type="primary"
        onClick={onCollectClick}
      >
        <Icon type="m-kuaisucaiji" className="fast-collect-button-icon" />
      </Button>
    </FastCollect>
  </div>
}
